export default function Home() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-3">
            <h2>Home</h2>
          </div>
        </div>
      </div>
    );
  }